export type PartVendorTradeStatus = 'ACTIVE' | 'SUSPENDED';

export type PartVendorAttachmentKind = 'BUSINESS_LICENSE' | 'OTHER';

export interface PartVendorAttachment {
  attachmentId: number;
  attachmentKind?: PartVendorAttachmentKind | string | null;
  fileName: string;
  contentType?: string | null;
  fileSize?: number | null;
  createdAt?: string | null;
}

export interface PartVendor {
  vendorId: number;
  vendorName: string;
  businessNumber?: string | null;
  ceoName?: string | null;
  businessType?: string | null;
  businessItem?: string | null;
  contactName?: string | null;
  contactPosition?: string | null;
  phone?: string | null;
  mobile?: string | null;
  fax?: string | null;
  email?: string | null;
  zipCode?: string | null;
  address?: string | null;
  addressDetail?: string | null;
  supplyItems?: string | null;
  paymentTerms?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  accountHolder?: string | null;
  tradeStatus?: PartVendorTradeStatus | string | null;
  memo?: string | null;
  attachmentCount?: number | null;
  attachments?: PartVendorAttachment[] | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface PartVendorPayload {
  vendorName: string;
  businessNumber?: string;
  ceoName?: string;
  businessType?: string;
  businessItem?: string;
  contactName?: string;
  contactPosition?: string;
  phone?: string;
  mobile?: string;
  fax?: string;
  email?: string;
  zipCode?: string;
  address?: string;
  addressDetail?: string;
  supplyItems?: string;
  paymentTerms?: string;
  bankName?: string;
  accountNumber?: string;
  accountHolder?: string;
  tradeStatus?: PartVendorTradeStatus;
  memo?: string;
}

export function partVendorLabel(row: Pick<PartVendor, 'vendorName' | 'contactName' | 'phone' | 'mobile'>) {
  const name = row.vendorName?.trim() || '업체명 없음';
  const contact = row.contactName?.trim() ? ` · ${row.contactName.trim()}` : '';
  const phoneRaw = row.mobile?.trim() || row.phone?.trim() || '';
  const phone = phoneRaw ? ` · ${phoneRaw}` : '';
  return `${name}${contact}${phone}`;
}

export function partVendorTradeStatusLabel(status?: string | null) {
  return status === 'SUSPENDED' ? '거래중단' : '거래중';
}

export function partVendorAttachmentKindLabel(kind?: string | null) {
  return kind === 'BUSINESS_LICENSE' ? '사업자등록증' : '기타 서류';
}

export function formatPartVendorAddress(row: Pick<PartVendor, 'zipCode' | 'address' | 'addressDetail'>) {
  const zip = row.zipCode?.trim() ? `(${row.zipCode.trim()}) ` : '';
  const addr = row.address?.trim() || '';
  const detail = row.addressDetail?.trim() ? ` ${row.addressDetail.trim()}` : '';
  const full = `${zip}${addr}${detail}`.trim();
  return full || '-';
}

export function formatFileSize(bytes?: number | null) {
  if (bytes == null || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export interface PartVendorTradeHistory {
  inspectionId: number;
  inventoryId?: number | null;
  itemName?: string | null;
  specText?: string | null;
  lotNo?: string | null;
  incomingQty?: string | null;
  status?: string | null;
  overallJudgment?: string | null;
  incomingDate?: string | null;
  inspectionDate?: string | null;
  inspectorName?: string | null;
  vendorContactName?: string | null;
  vendorPhone?: string | null;
  createdAt?: string | null;
}
